import { type Palette, type PaletteColor, type ButtonOwnProps } from '@mui/material'
import { hasOwnProperty } from '../../../helpers'

type ButtonColor = ButtonOwnProps['color'] | undefined
export type GetPaletteColor = (color: ButtonColor) => PaletteColor | undefined

export const getButtonPalette = (palette: Palette, color: ButtonColor): PaletteColor | undefined => {
  const eligibleColor = !!color && color !== 'inherit' ? color : undefined
  return eligibleColor && hasOwnProperty<Palette>(palette, eligibleColor)
    ? (palette[eligibleColor] as PaletteColor)
    : undefined
}
